import React from 'react';
import { useSelector } from 'react-redux';
import { DateTimeUtils } from 'dyl-components';

export const GetTimezone = () => {
    const userAuthTimezone = useSelector((state) => state.auth.timezone);
    const {timezone=userAuthTimezone} = useSelector(state => state.user.userProfile);
    return timezone;
}

const TZDisplay = () => { 
    const TIMEZONE_OPTIONS = DateTimeUtils.generateTimezoneOptions();
    const timeZoneDisplay =  TIMEZONE_OPTIONS.find(timeZone => timeZone.key === GetTimezone()).description;
    return (
        <span> {timeZoneDisplay} </span>
    )
}

export default TZDisplay;
